"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var preact_1 = require("preact");
var YotpoShareReviewButton = function (_a) {
    var productId = _a.productId, shareReviewButtonText = _a.shareReviewButtonText;
    return ((0, preact_1.h)("a", { href: "/pages/write-a-review?product_id=".concat(productId), target: '_blank', class: 'yotpo-write-review__button' }, shareReviewButtonText));
};
exports.default = YotpoShareReviewButton;
